

  <div class="services container">
      <h3>Dashboard</h3>
  </div>
    

    <div class="article-display">


      <!-- Row for Article Details -->
      <div class="row">                          
          <div class="column">                      
            <h4>Selected Article</h4>
          </div>
          <div class="column label-value">
            <div class="label-input-pair">   
              <div class="label-input-pair">
                <select [(ngModel)]="selectedProject" (ngModelChange)="onProjectChange()">
                  <option *ngFor="let key of config?.projects | keyvalue" [value]="key.key">{{ key.key }}</option>
                </select>
              </div>
              <div class="search-box">
                <select [(ngModel)]="selectedFile">
                    <option value="home-page">home-page</option>
                    <option value="service-page">service-page</option>
                    <option value="aboutus-page">aboutus-page</option>
                    <option value="price-page">price-page</option>
                </select>
              </div>         
              <div class="label-input-pair">
                <select [(ngModel)]="selectedServiceType">
                  <option *ngFor="let serviceType of config?.projects[selectedProject]?.service_types" [value]="serviceType">{{ serviceType }}</option>
                </select>
              </div>
            <div class="search-box">
                  <input type="number" [(ngModel)]="selectedId" placeholder="Enter ID" (ngModelChange)="onIdChange()">
              </div>
            </div>
          </div>
          <div class="column image-container">    
              <!-- Button to Log Data -->
              <div class="button-container">
                  <button (click)="logData()">Log JSON Data</button>
                  <button (click)="loadNewData()">Load the New JSON</button>
                  <button (click)="updateJsonData(selectedId,'en',selectedService[0])">Save EN</button>
                  <button (click)="updateJsonData(selectedId,'ar',selectedService[1])">Save Ar</button>
                  <button (click)="updateJsonData(selectedId,'de',selectedService[2])">Save De</button>
              </div>        
          </div>
        </div>

     <!-- Row for Article Configuration -->
     <div class="row">
      <div class="column">
        <h4>Article Configuration</h4>
      </div>
      <div class="column label-value">
        <div class="label-input-pair">
            <label>Article Code:</label>            
            <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].articleCode" rows="4"></textarea>            
            <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].articleCode" rows="4"></textarea>            
            <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].articleCode" rows="4"></textarea>            
            
          </div>
        <div class="label-input-pair">
          <label>Title:</label>
          <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].title" rows="4"></textarea>
          <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].title" rows="4"></textarea>
          <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].title" rows="4"></textarea>
        </div>
        <div class="label-input-pair">
          <label>Summary:</label>
          <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].summary" rows="4"></textarea>
          <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].summary" dir="rtl" rows="4"></textarea>
          <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].summary" rows="4"></textarea>
        </div>
        <div class="label-input-pair">
          <label>Button Text:</label>
          <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].buttonText" rows="4"></textarea>
          <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].buttonText" dir="rtl" rows="4"></textarea>
          <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].buttonText" rows="4"></textarea>
        </div>        
        <div class="label-input-pair">
            <label>Image Path:</label>
            <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].imageIconPath" rows="4"></textarea>
            <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].imageIconPath" rows="4"></textarea>
            <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].imageIconPath" rows="4"></textarea>
        </div>        
        <div class="label-input-pair">
        <label>Image Alt:</label>
        <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].imageAlt" rows="4"></textarea>
        <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].imageAlt" dir="rtl" rows="4"></textarea>
        <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].imageAlt" rows="4"></textarea>
        </div>        
      </div>
      
      <div class="column image-container">
        <img *ngIf="selectedService[0]" [src]="selectedService[0].imageIconPath" alt="{{ selectedService[0].imageAlt }}">
        <p *ngIf="selectedService[0]">{{ selectedService[0].imageAlt }}</p>
        <p *ngIf="selectedService[1]" dir="rtl">{{ selectedService[1].imageAlt }}</p>
        <p *ngIf="selectedService[2]">{{ selectedService[2].imageAlt }}</p>
      </div>
    </div>
    
  <!-- Row for Article Details -->
  <div class="row">
    <div class="column">
      <h4>Article Details</h4>
    </div>
    <div class="column label-value">
      <div class="label-input-pair">
        <label>Category:</label>
        <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].category" rows="4"></textarea>
        <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].category" rows="4"></textarea>
        <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].category" rows="4"></textarea>
      </div>
      <div class="label-input-pair">
          <label>Image Path:</label>
          <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].imageUrl" rows="4"></textarea>
          <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].imageUrl" rows="4"></textarea>
          <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].imageUrl" rows="4"></textarea>
      </div>        
      <div class="label-input-pair">
      <label>Image Alt:</label>
      <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].imageUrlALt" rows="4"></textarea>
      <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].imageUrlALt" dir="rtl" rows="4"></textarea>
      <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].imageUrlALt" rows="4"></textarea>
      </div>        
      <div class="label-input-pair">
        <label>Video Path:</label>
        <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].video" rows="4"></textarea>
        <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].video" rows="4"></textarea>
        <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].video" rows="4"></textarea>
        </div>        
    </div>
    <div class="column image-container">
      <img *ngIf="selectedService[0]" [src]="selectedService[0].imageUrl" alt="{{ selectedService[0].imageUrlALt }}">
      <p *ngIf="selectedService[0]">{{ selectedService[0].imageUrlALt }}</p>
      <p *ngIf="selectedService[1]" dir="rtl">{{ selectedService[1].imageUrlALt }}</p>
      <p *ngIf="selectedService[2]">{{ selectedService[2].imageUrlALt }}</p>
    </div>
  </div>

  <!-- Row for Metadata -->
  <div class="row">
    <div class="column">
      <h4>Meta Data</h4>
    </div>
    <div class="column" *ngIf="selectedService[0]">
      <div *ngFor="let key of objectKeys(selectedService[0].meta)" class="label-input-pair">
        <label>{{ key | titlecase }}:</label>
        <textarea *ngIf="selectedService[0]" [(ngModel)]="selectedService[0].meta[key]" rows="4"></textarea>
        <textarea *ngIf="selectedService[1]" [(ngModel)]="selectedService[1].meta[key]" dir="rtl" rows="4"></textarea>
        <textarea *ngIf="selectedService[2]" [(ngModel)]="selectedService[2].meta[key]" rows="4"></textarea>
      </div>
    </div>
    <!-- Intentionally left empty -->
  </div>
  </div>

  
  <div class="htmlcontainer" *ngIf="selectedService[0]">
    <div class="row">
      <!-- Column for Raw HTML Code -->
      <div class="col half-width">
        <h3>HTML Code</h3>
        <!-- Two-way data binding to update selectedService[0].htmlContent -->
        <textarea [(ngModel)]="selectedService[0].htmlContent" rows="80" cols="120"></textarea>
      </div>
      <!-- Column for Rendered HTML -->
      <div class="col half-width">
        <h3>Rendered HTML</h3>
        <div [innerHTML]="selectedService[0].htmlContent"></div>
      </div>
    </div>
  </div>
    
  <div class="htmlcontainer" *ngIf="selectedService[1]">
    <div class="row">
      <!-- Column for Raw HTML Code -->
      <div class="col half-width">
        <h3>HTML Code</h3>
        <!-- Two-way data binding to update selectedService[0].htmlContent -->
        <textarea [(ngModel)]="selectedService[1].htmlContent" dir="rtl" rows="80" cols="120"></textarea>
      </div>
      <!-- Column for Rendered HTML -->
      <div class="col half-width">
        <h3>Rendered HTML</h3>
        <div [innerHTML]="selectedService[1].htmlContent" dir="rtl"></div>
      </div>
    </div>
  </div>


  <div class="htmlcontainer" *ngIf="selectedService[2]">
    <div class="row">
      <!-- Column for Raw HTML Code -->
      <div class="col half-width">
        <h3>HTML Code</h3>
        <!-- Two-way data binding to update selectedService[0].htmlContent -->
        <textarea [(ngModel)]="selectedService[2].htmlContent" rows="80" cols="120"></textarea>
      </div>
      <!-- Column for Rendered HTML -->
      <div class="col half-width">
        <h3>Rendered HTML</h3>
        <div [innerHTML]="selectedService[2].htmlContent"></div>
      </div>
    </div>
  </div>
    
